import type { Genie2ReportingMode } from '~/utils/analyticsReportingMode';

/**
 * Shared scope for staff / parent_delegate analytics access queries.
 * `analyticsReportingMode` is included in query keys as null when omitted (live account).
 */
export type StatAccessQueryScope = {
  /** Parent client id — when set, uses children mount (parent_delegate). */
  parentAccountId?: string | null;
  /**
   * Pre-seed universe while persisted mode is `legacy`.
   * Live accounts omit (null). Never send `legacy`.
   */
  analyticsReportingMode?: Genie2ReportingMode | null;
};

export function staffConfigModeQueryParams(
  analyticsReportingMode?: Genie2ReportingMode | null,
  extra?: Record<string, string>,
): Record<string, string> | undefined {
  const params: Record<string, string> = { ...extra };
  if (analyticsReportingMode === 'v2' || analyticsReportingMode === 'v2_legacy') {
    params.analyticsReportingMode = analyticsReportingMode;
  }
  return Object.keys(params).length > 0 ? params : undefined;
}

export function staffConfigModeQueryKeyPart(
  analyticsReportingMode?: Genie2ReportingMode | null,
): Genie2ReportingMode | null {
  return analyticsReportingMode === 'v2' || analyticsReportingMode === 'v2_legacy'
    ? analyticsReportingMode
    : null;
}
